import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";



const Editor = ({ value, setDescriptionHandle, setIdHandle, setLangHandle, setNameHandle,setSeoDesHandle,setSeoTitleHandle }) => {
  const handleChange = (e, editor) => {
    const data = editor.getData();
    setDescriptionHandle(data);
    setIdHandle(value?.id);
    setLangHandle(value?.languageKey);
    setNameHandle(value?.name);
    setSeoTitleHandle(value?.seoTitle);
    setSeoDesHandle(value?.seoDescription);
  };

  return (
    <>
      <CKEditor
        editor={ClassicEditor}
        data={value?.description || ''}
        onChange={handleChange}
        config={{
          heading: {
            options: [
              { model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
              { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
              { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
              { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            ],
          },
        }}
      />

    </>
  );
};

export default Editor;
